import { render, staticRenderFns } from "./RecommendList.vue?vue&type=template&id=148e7cef"
import script from "./RecommendList.ts?vue&type=script&lang=ts&external"
export * from "./RecommendList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports